import { forwardRef } from 'react'

import { IconProps } from '../../../types/types'

export const TradeInSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	const { size = 24, ...rest } = props

	return (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...rest}>
			<path
				d="M15.9066 20.0003L22 14.839L15.9066 9.67773V11.7423H12.5556V10.3996H5.05562V11.7423C5.05562 14.984 7.67119 17.6184 10.9128 17.6418L15.9066 17.6777V20.0003Z"
				fill="#4A4A4A"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.28951 4L1.99958 9.16129L5.33291 11.6007L5.53979 11.7426H5.54075L8.24951 13.6V11.7426H15.9062V9.67805L19.2563 12.5157L19.2969 12.5161C19.2969 9.09553 16.5239 6.32258 13.1033 6.32258L8.28951 6.32258V4Z"
				fill="url(#paint0_linear_13382_131578)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_13382_131578"
					x1="19.2218"
					y1="5.6"
					x2="6.57637"
					y2="13.2484"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#F4F8FC" />
					<stop offset="1" stopColor="#568DFE" />
				</linearGradient>
			</defs>
		</svg>
	)
})
